<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">分享素材</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="10px" class="user-search">
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="addBanner">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="url" label="图片" width="300">
            <template slot-scope="scope" align="center">
                <el-image
                style="width: 200px; height: 100px"
                class="img_inner"
                :src="queryUrl + scope.row.file"
                fit="fit"></el-image>
            </template>
        </el-table-column>
        <el-table-column  prop="title" label="分享标题" >
        </el-table-column>
        <el-table-column  prop="type" label="分享类型" >
            <template slot-scope="scope" align="center">
                <span v-if="scope.row.type == 1">小程序分享</span>
                <span v-if="scope.row.type == 2">观战分享</span>
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
            <template slot-scope="scope">
            <el-button size="mini" type="danger" v-preventReClick @click="delInfomercial(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="类型" prop="type">
                    <el-select v-model="editForm.type" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                <el-input size="small" v-model="editForm.title" style="width:220px" auto-complete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                        :http-request="handleChange"
                        :file-list="fileList"
                        accept=".jpg , .png , .mp4"
                        >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" v-preventReClick type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>

</div>
</template>
<script>

import Pagination from '../../../components/Pagination'
import { loadShareConfigList , deleteShareConfig} from '../../../api/userMG'
export default {
    data(){
        return{
            rules: {
                type : [
                { required: true, message: '请选择', trigger: 'blur' }
                ],
                title : [
                { required: true, message: '请输入', trigger: 'blur' }
                ],
                num: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ],
            },
            editSubForm:{},
            editFlag:false,
            fileList:[],
            options:[
                {
                value: '1',
                label: '小程序分享'
                }, {
                value: '2',
                label: '观战分享'
                },
            ],
            options2:[{
                value: '1',
                label: '图片'
                }, {
                value: '0',
                label: '视频'
                },],
            editForm:{
                type:'',
                title:''
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        Pagination,
        
    },
    created(){
        this.getdata()
        console.log(this.queryUrl)
    },
    methods:{
        
        // 新建提交
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    let data = this.editForm
                    data.position = 0
                    let formData = new FormData()
                    if(this.fileList[0] == undefined){
                        this.$message.error('上传图片')
                        return
                    } 
                    formData.append('uplaodFile' , this.fileList[0])
                    formData.append('type' ,data.type)
                    formData.append('title' ,data.title)
                    this.$axios({
                        method: "POST",
                        url: "/yunyue-houtai/admin/createShareConfig",
                        headers: {
                        "Content-Type": "multipart/form-data",
                        token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                        },
                        data: formData,
                    }).then(res=>{
                        console.log(res)
                        if(res.data.success == true){
                            this.$message.success('创建成功')
                            this.editFormVisible = false
                            this.getdata()
                            this.editForm = {
                                type:'',
                                title:''
                            }
                            this.fileList = []
                        }else {
                            this.$message.console.error(res.data.messages)
                        }
                        
                    })
                } else {
                    return false
                }
            })
            
        },
        // 删除
        delInfomercial(index , row){
            this.$confirm('是否确认删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                deleteShareConfig({
                    id :row.id,
                }).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.messages
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除！'
                })
            })
        },
        handleChange(file){
            console.log(file)
            this.fileList = [file.file] 
            console.log(this.fileList)
        },
        closeDialog(){
            this.editFormVisible = false
            this.fileList = []
            this.editForm = {
                type:'',
                title:''
            }
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            loadShareConfigList({
            }).then(res=>{
                this.listData = res.configs
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .img_inner{
    transform: all .3s;
    cursor: pointer;
  }
  .img_inner:hover{
    transform: scale(1.2);
  }
</style>


// WEBPACK FOOTER //
// src/views/AdvertisingManagement/SharingMaterials/index.vue